module.exports = __webpack_public_path__ + "static/media/doc-retrieval-mailbox-min.1a9f5a3a.png";